import React , {Component}   from 'react';
import CardList from '../components/CardList';
import SearchBox from '../components/SearchBox';
import './App.css';
import Scroll from '../components/Scroll';
import ErrorBoundry from '../components/ErrorBoundry';



class App extends Component {
   constructor() {
   	super()
   	this.state = {
   		robots: [],
   		searchfield: ''
	   }
   }

   componentDidMount(){
   	fetch('https://jsonplaceholder.typicode.com/users')
   	  .then(response => response.json())
   	  .then(users => this.setState({ robots: users}));
   }

   onSearchChange = (event) => {
   	this.setState({searchfield: event.target.value})
   }

   getFilteredRobots = () => {
   	const {robots, searchfield} = this.state;
   	return robots.filter(robot => {
   		const searchfieldInName = robot.name.toLowerCase().includes(searchfield.toLowerCase());
   		const searchfieldInEmail = robot.email.toLowerCase().includes(searchfield.toLowerCase()); 
   	   return searchfieldInEmail || searchfieldInName;
   	})
   }

   render() {
   	return !this.state.robots.length ?
   		 <h1 className='tc'>Loading</h1> : (
		    	<div className='tc'>
					  <h1 className='f2'>RoboFriends</h1>
					  <SearchBox searchChange={this.onSearchChange} />
					  <Scroll>
					    <ErrorBoundry>
					  	    <CardList robots={this.getFilteredRobots()}/>
					  	 </ErrorBoundry>   
					  </Scroll>	
				</div>  		
			);
		}
 }	


export default App;